import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Mayden Films';
const DEFAULT_IMAGE = 'https://glam-capture.emergent.host/og-image.jpg';

// Australian English SEO wrapper. Structured data uses the public service
// area only — never a residential/verification address.
export const Seo = ({
  title,
  exactTitle,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  jsonLd,
}) => {
  const fullTitle = exactTitle || (title ? `${title} · ${SITE_NAME}` : SITE_NAME);
  const url = `https://maydenfilms.com${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="en_AU" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export const LOCAL_BUSINESS_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Mayden Films',
  description:
    'Mayden Films offers premium Glam Booth hire, event photography, portrait and creative sessions, cinematic videography and creative projects across Cranbourne and Southeast Melbourne.',
  telephone: '+61449995495',
  email: 'mf.maydenfilms@gmail.com',
  url: 'https://maydenfilms.com',
  image: DEFAULT_IMAGE,
  priceRange: '$$',
  areaServed: [
    'Cranbourne', 'City of Casey', 'Pakenham', 'Dandenong',
    'Frankston', 'Mornington Peninsula', 'Greater Melbourne',
  ],
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Cranbourne',
    addressRegion: 'VIC',
    addressCountry: 'AU',
  },
  sameAs: [
    'https://www.instagram.com/mayden_films',
    'https://www.facebook.com/maydenfilms',
  ],
};

export default Seo;
